import type { ControlSummary } from '../api.ts';

interface ThresholdsProps {
  controls: ControlSummary[];
  overrides: Record<string, Record<string, unknown>>;
}

export const Thresholds = ({ controls, overrides }: ThresholdsProps) => {
  const parameterised = controls.filter(
    (control) => Object.keys(control.parameters).length > 0,
  );

  return (
    <>
      <p className="note td-lead">
        Thresholds applied to this client. The effective value is recorded on every finding, so a
        reader can always see which threshold produced the verdict.
      </p>
      <div className="tbl-wrap">
        <table className="tbl td-thresholds">
          <thead>
            <tr>
              <th scope="col">Control</th>
              <th scope="col">Catalogue default</th>
              <th scope="col">Override in force</th>
            </tr>
          </thead>
          <tbody>
            {parameterised.length === 0 ? (
              <tr>
                <td colSpan={3} className="note">
                  No control in the catalogue takes a threshold.
                </td>
              </tr>
            ) : (
              parameterised.map((control) => (
                <tr key={control.id}>
                  <th scope="row" className="td-control">
                    <span className="mono">{control.id}</span>
                    <span className="td-control-title">{control.title}</span>
                  </th>
                  <td className="mono">
                    {Object.entries(control.parameters)
                      .map(([name, spec]) => `${name}=${String(spec.default)}`)
                      .join(', ')}
                  </td>
                  <td className="mono">
                    {overrides[control.id]
                      ? Object.entries(overrides[control.id] ?? {})
                          .map(([name, value]) => `${name}=${String(value)}`)
                          .join(', ')
                      : '—'}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};
